import React from 'react';
import { safeRest } from '@wds/utils';
import { createMemoStyles, getColor } from '@wds/styles';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __rest$1(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

var useStyles$1 = createMemoStyles(function (_a) {
    var palette = _a.palette, type = _a.type, iconSize = _a.iconSize;
    return ({
        wrenchIcons: {
            display: 'inline-block',
            fill: function (_a) {
                var color = _a.color, onDark = _a.onDark;
                return getColor(palette, color, undefined, onDark);
            },
            fontFamily: type.fontFamily.base,
            fontSize: function (_a) {
                var size = _a.size;
                return size ? iconSize[size] : 'inherit';
            },
            '-webkit-font-smoothing': 'antialiased',
            margin: '0 auto',
            height: '1em',
            textAlign: 'center',
            verticalAlign: 'middle',
            width: '1em',
        },
    });
});

function withIcon(Component) {
    var WithIcon = function (_a) {
        var color = _a.color, _b = _a.onDark, onDark = _b === void 0 ? false : _b, title = _a.title, size = _a.size, rest = __rest(_a, ["color", "onDark", "title", "size"]);
        var wrenchIcons = useStyles$1({ color: color, onDark: onDark, size: size }).wrenchIcons;
        return (React.createElement("svg", __assign({ className: wrenchIcons, viewBox: "0 0 16 16", preserveAspectRatio: "xMidYMid", "aria-label": title, role: "img" }, safeRest(rest)),
            React.createElement(Component, null)));
    };
    WithIcon.displayName = "WithIcon(".concat(Component.name, ")");
    WithIcon.getOriginalComponent = function () { return Component; };
    return WithIcon;
}

var IconArrowBox = function () {
    return (React.createElement("g", null,
        React.createElement("path", { d: "m1.05 2 4.2.006A.75.75 0 0 1 5.354 3.5l-.102.007L1.5 3.5V14.5h11v-3.75a.75.75 0 0 1 1.5 0v4.2c0 .541-.41.987-.936 1.044L12.95 16H1.05a1.05 1.05 0 0 1-1.044-.936L0 14.95V3.05c0-.54.41-.986.936-1.043L1.05 2zM15.3 0a.7.7 0 0 1 .7.7v6.55a.75.75 0 1 1-1.5 0V2.561L9.27 7.789a.75.75 0 0 1-1.133-.976l.073-.084L13.438 1.5H8.75a.75.75 0 0 1 0-1.5h6.55z" })));
};
// pure annotation needed for tree-shaking
var ArrowBox = /* #__PURE__ */ withIcon(IconArrowBox);

var useStyles = createMemoStyles(function (_a) {
    var palette = _a.palette, type = _a.type, spacing = _a.spacing;
    return ({
        wrenchLink: function (_a) {
            var color = _a.color, underline = _a.underline;
            return ({
                fontFamily: type.fontFamily.base,
                '-webkit-font-smoothing': 'antialiased',
                color: color === 'light' ? palette.text.light : palette.text.link,
                border: 'none',
                background: 'none',
                fontWeight: 'inherit',
                fontSize: 'inherit',
                cursor: 'pointer',
                textDecoration: underline ? 'underline' : 'none',
                '&:hover, &:focus': {
                    textDecoration: underline ? 'none' : 'underline',
                },
            });
        },
        wrenchLinkNewTab: function () { return ({
            paddingLeft: spacing[1],
        }); },
    });
});

var Link = function (_a) {
    var children = _a.children, color = _a.color, _b = _a.underline, underline = _b === void 0 ? true : _b, rest = __rest$1(_a, ["children", "color", "underline"]);
    var _c = useStyles({ color: color, underline: underline }), wrenchLink = _c.wrenchLink, wrenchLinkNewTab = _c.wrenchLinkNewTab;
    var newTabIcon = rest.target && rest.target === '_blank' ? (React.createElement("span", { className: wrenchLinkNewTab },
        React.createElement(ArrowBox, { title: "New Tab" }))) : null;
    if (newTabIcon) {
        return (React.createElement("a", __assign$1({ className: wrenchLink }, safeRest(rest)),
            children,
            newTabIcon));
    }
    return (React.createElement("a", __assign$1({ className: wrenchLink }, safeRest(rest)), children));
};

var LINK_COLORS = ['light', 'dark'];

export { LINK_COLORS, Link };
